"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableSortLabelOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            // Using overly specific selectors to match MUI implementation
            "&:focus": {
                color: undefined,
            },
            "&.Mui-focusVisible": {
                color: palette.text.primary,
            },
            "&:hover": {
                color: palette.text.primary,
                "& $icon": {
                    opacity: 1,
                },
            },
            "&$active": {
                color: undefined,
                "&& $icon": {
                    color: palette.text.primary,
                },
            },
        },
        icon: {
            fontSize: 12,
        },
    });
};
//# sourceMappingURL=MuiTableSortLabel.js.map